import { Box, Text, Wrap, WrapItem } from '@chakra-ui/react'
import React from 'react'
import { useCanHover } from '../hooks/utility/useCanHover'
import { useLanguage } from '../hooks/utility/useLanguage'
import { UploadedAsset } from '../types/chatTypes'
import CopyButton from './buttons/CopyButton'
import { MessageAttachment } from './DocumentAttachment/DocumentAttachment'

interface Props {
  message: string
  attachedDocuments?: UploadedAsset[]
}

// eslint-disable-next-line react/display-name
const UserChatMessageComponent: React.FC<Props> = ({ message, attachedDocuments }) => {
  const canHover = useCanHover()
  const { t } = useLanguage()

  return (
    <Box
      data-group
      display='flex'
      flexDirection='column'
      alignItems='flex-end'
      justifyContent='flex-end'
      mt={5}
      ml='auto'
      maxWidth='80%'
      position='relative'
      data-dd-privacy='mask'
    >
      {!!attachedDocuments?.length && (
        <Wrap mb={2} spacing={2} justify='flex-end'>
          {attachedDocuments.map(document => (
            <WrapItem key={document.id}>
              <MessageAttachment document={document} />
            </WrapItem>
          ))}
        </Wrap>
      )}
      <Box
        bg='chat.userBubble'
        px={4}
        py={3}
        width='fit-content'
        borderRadius='chat.bubble'
        borderBottomRightRadius='chat.bubble'
        fontSize='md'
        lineHeight='tall'
        position='relative'
      >
        {/* Message text */}
        <Text color='chat.userInk' whiteSpace='pre-wrap' overflowWrap='anywhere'>
          {message}
        </Text>
      </Box>
      {/* Inside the hover area, so it stays shown on the way to it. Always shown on touch. */}
      <Box
        mr={1}
        opacity={canHover ? 0 : 1}
        pointerEvents={canHover ? 'none' : 'auto'}
        _groupHover={canHover ? { opacity: 1, pointerEvents: 'auto' } : undefined}
        _groupFocusWithin={canHover ? { opacity: 1, pointerEvents: 'auto' } : undefined}
        transition='opacity 0.2s'
      >
        <CopyButton
          textToCopy={message}
          ariaLabel={t('common.copyMessage')}
          size='xs'
          variant='ghost'
          color='gray.600'
        />
      </Box>
    </Box>
  )
}

UserChatMessageComponent.displayName = 'UserChatMessage'

export const UserChatMessage = React.memo(UserChatMessageComponent)
